module.exports = __webpack_public_path__ + "static/img/btn_omygod_shop.43666094.jpg";